import { components } from './components';
import { scenes } from './scenes';
import { services } from './services';
import { toast } from './toast';

const fr = {
  locale: 'fr',
  messages: {
    components,
    scenes,
    services,
    toast,
  },
};

export { fr };
